export default "__VITE_ASSET__CBqrUjWH__"